import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  FormFeedback,
} from 'reactstrap';
import logo200Image from '../assets/img/Bahir_Dar__2_-removebg-preview.png';

export const STATE_LOGIN = 'LOGIN';
export const STATE_SIGNUP = 'SIGNUP';

class AuthForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      phone: '',
      password: '',
      confirmPassword: '',
      rememberMe: false,
      errors: {},
    };
  }

  get isLogin() {
    return this.props.authState === STATE_LOGIN;
  }

  get isSignup() {
    return this.props.authState === STATE_SIGNUP;
  }

  changeAuthState = authState => event => {
    event.preventDefault();
    this.setState({ errors: {}, password: '', confirmPassword: '' }); // reset form state
    this.props.onChangeAuthState(authState);
  };

  handleInputChange = e => {
    const { name, value, type, checked } = e.target;
    this.setState({
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  validate = () => {
    const { firstName, phone, password, confirmPassword } = this.state;
    const errors = {};

    if (!phone) {
      errors.phone = 'Phone is required';
    } else if (!/^\+?[0-9]{7,15}$/.test(phone)) {
      errors.phone = 'Phone number is invalid';
    }

    if (!password) errors.password = 'Password is required';
    else if (password.length < 6)
      errors.password = 'Password must be at least 6 characters';

    if (this.isSignup) {
      if (!firstName) {
        errors.firstName = 'First name is required';
      }
      if (!confirmPassword) errors.confirmPassword = 'Confirm your password';
      else if (password !== confirmPassword)
        errors.confirmPassword = 'Passwords do not match';
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleSubmit = event => {
    event.preventDefault();
    if (this.validate()) {
      const { firstName, phone, password, rememberMe } = this.state;
      const payload = { firstName, phone, password };
      // console.log('payload data is : ', payload);
      // if (this.isSignup) {
      //   payload.confirmPassword = this.state.confirmPassword;
      // }

      if (this.props.onSubmit) {
        this.props.onSubmit(payload, this.props.authState);
      }
    }
  };

  renderButtonText() {
    const { buttonText } = this.props;

    if (!buttonText && this.isLogin) return 'Login';
    if (!buttonText && this.isSignup) return 'Signup';

    return buttonText;
  }

  render() {
    const {
      showLogo,
      usernameLabel,
      phoneLabel,
      passwordLabel,
      confirmPasswordLabel,
      children,
      onLogoClick,
    } = this.props;

    const { firstName, phone, password, confirmPassword, rememberMe, errors } =
      this.state;

    return (
      <Form onSubmit={this.handleSubmit}>
        {showLogo && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              paddingBottom: '1rem',
            }}
          >
            <img
              src={logo200Image}
              className="rounded"
              style={{ width: 100, height: 100, cursor: 'pointer' }}
              alt="logo"
              onClick={onLogoClick}
            />
          </div>
        )}
        {this.isSignup && (
          <FormGroup>
            <Label for="name">{usernameLabel}</Label>
            <Input
              type="text"
              name="firstName"
              placeholder="e.g Danie"
              value={firstName}
              onChange={this.handleInputChange}
              invalid={!!errors.firstName}
            />
            <FormFeedback>{errors.firstName}</FormFeedback>
          </FormGroup>
        )}
        <FormGroup>
          <Label for="phone">{phoneLabel}</Label>
          <Input
            type="phone"
            name="phone"
            placeholder="(+251) 943 064 628"
            value={phone}
            onChange={this.handleInputChange}
            invalid={!!errors.phone}
          />
          <FormFeedback>{errors.phone}</FormFeedback>
        </FormGroup>

        <FormGroup>
          <Label for="password">{passwordLabel}</Label>
          <Input
            type="password"
            name="password"
            placeholder="your password"
            value={password}
            onChange={this.handleInputChange}
            invalid={!!errors.password}
          />
          <FormFeedback>{errors.password}</FormFeedback>
        </FormGroup>

        {this.isSignup && (
          <FormGroup>
            <Label for="confirmPassword">{confirmPasswordLabel}</Label>
            <Input
              type="password"
              name="confirmPassword"
              placeholder="confirm your password"
              value={confirmPassword}
              onChange={this.handleInputChange}
              invalid={!!errors.confirmPassword}
            />
            <FormFeedback>{errors.confirmPassword}</FormFeedback>
          </FormGroup>
        )}

        <FormGroup check>
          <Label check>
            <Input
              type="checkbox"
              name="rememberMe"
              checked={rememberMe}
              onChange={this.handleInputChange}
            />{' '}
            {this.isSignup ? (
              <>
                Agree to the{' '}
                <a
                  href="/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  terms and policy
                </a>
              </>
            ) : (
              'Remember me'
            )}
          </Label>
        </FormGroup>

        <hr />
        <Button
          size="lg"
          className="bg-gradient-theme-left border-0"
          block
          type="submit"
          disabled={this.props.loading} // ⬅️ disable while loading
        >
          {this.props.loading ? (
            <>
              <div
                class="inline-block h-8 w-8 animate-[spinner-grow_0.75s_linear_infinite] rounded-full bg-current align-[-0.125em] text-surface opacity-0 motion-reduce:animate-[spinner-grow_1.5s_linear_infinite] dark:text-white"
                role="status"
              >
                <span class="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
                  Loading...
                </span>
              </div>
            </>
          ) : (
            this.renderButtonText()
          )}
        </Button>

        <div className="text-center pt-1">
          <h6>or</h6>
          <h6>
            {this.isSignup ? (
              <a href="#login" onClick={this.changeAuthState(STATE_LOGIN)}>
                Login
              </a>
            ) : (
              <a href="#signup" onClick={this.changeAuthState(STATE_SIGNUP)}>
                Signup
              </a>
            )}
          </h6>
        </div>

        {children}
      </Form>
    );
  }
}

AuthForm.propTypes = {
  authState: PropTypes.oneOf([STATE_LOGIN, STATE_SIGNUP]).isRequired,
  showLogo: PropTypes.bool,
  usernameLabel: PropTypes.string,
  phoneLabel: PropTypes.string,
  passwordLabel: PropTypes.string,
  confirmPasswordLabel: PropTypes.string,
  onLogoClick: PropTypes.func,
  onChangeAuthState: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  buttonText: PropTypes.string,
  children: PropTypes.node,
};

AuthForm.defaultProps = {
  authState: STATE_LOGIN,
  showLogo: true,
  usernameLabel: 'firstName',
  phoneLabel: 'phone',
  passwordLabel: 'Password',
  confirmPasswordLabel: 'Confirm Password',
  onLogoClick: () => {},
};

export default AuthForm;
